import React from "react";
import { Table } from "react-bootstrap";
import "../../../assets/styles/informationLayer.scss";

const InformationLayerData = ({ addressData }) => {
  const renderValue = (value) => {
    if (typeof value === "boolean") return value ? "TAK" : "NIE";
    if (value === null || value === undefined) return "-";
    if (typeof value === "string" && value.trim() === "") return "-";
    return value;
  };

  return (
    <Table className="layer-table" responsive>
      <tbody>
        <tr>
          <td>ID:</td>
          <td>{addressData.id}</td>
        </tr>
        <tr>
          <td>Terminal DX:</td>
          <td>{renderValue(addressData.terminalEx)}</td>
        </tr>
        <tr>
          <td>Terminal DR:</td>
          <td>{renderValue(addressData.terminalDr)}</td>
        </tr>
        <tr>
          <td>EX PN:</td>
          <td>{renderValue(addressData.exPn)}</td>
        </tr>
        <tr>
          <td>EX WT:</td>
          <td>{renderValue(addressData.exWt)}</td>
        </tr>
        <tr>
          <td>EX SR:</td>
          <td>{renderValue(addressData.exSr)}</td>
        </tr>
        <tr>
          <td>EX CZ:</td>
          <td>{renderValue(addressData.exCz)}</td>
        </tr>
        <tr>
          <td>EX PT:</td>
          <td>{renderValue(addressData.exPt)}</td>
        </tr>
        <tr>
          <td>EX SO:</td>
          <td>{renderValue(addressData.exSo)}</td>
        </tr>
        <tr>
          <td>DR PN:</td>
          <td>{renderValue(addressData.drPn)}</td>
        </tr>
        <tr>
          <td>DR WT:</td>
          <td>{renderValue(addressData.drWt)}</td>
        </tr>
        <tr>
          <td>DR SR:</td>
          <td>{renderValue(addressData.drSr)}</td>
        </tr>
        <tr>
          <td>DR CZ:</td>
          <td>{renderValue(addressData.drCz)}</td>
        </tr>
        <tr>
          <td>DR PT:</td>
          <td>{renderValue(addressData.drPt)}</td>
        </tr>
        <tr>
          <td>DR SO:</td>
          <td>{renderValue(addressData.drSo)}</td>
        </tr>
        <tr>
          <td>W PN:</td>
          <td>{renderValue(addressData.wPn)}</td>
        </tr>
        <tr>
          <td>W WT:</td>
          <td>{renderValue(addressData.wWt)}</td>
        </tr>
        <tr>
          <td>W SR:</td>
          <td>{renderValue(addressData.wSr)}</td>
        </tr>
        <tr>
          <td>W CZ:</td>
          <td>{renderValue(addressData.wCz)}</td>
        </tr>
        <tr>
          <td>W PT:</td>
          <td>{renderValue(addressData.wPt)}</td>
        </tr>
        <tr>
          <td>RES PN OD:</td>
          <td>{renderValue(addressData.resPnOd)}</td>
        </tr>
        <tr>
          <td>RES PN DO:</td>
          <td>{renderValue(addressData.resPnDo)}</td>
        </tr>
        <tr>
          <td>RES WT OD:</td>
          <td>{renderValue(addressData.resWtOd)}</td>
        </tr>
        <tr>
          <td>RES WT DO:</td>
          <td>{renderValue(addressData.resWtDo)}</td>
        </tr>
        <tr>
          <td>RES SR OD:</td>
          <td>{renderValue(addressData.resSrOd)}</td>
        </tr>
        <tr>
          <td>RES SR DO:</td>
          <td>{renderValue(addressData.resSrDo)}</td>
        </tr>
        <tr>
          <td>RES PT OD:</td>
          <td>{renderValue(addressData.resPtOd)}</td>
        </tr>
        <tr>
          <td>RES PT DO:</td>
          <td>{renderValue(addressData.resPtDo)}</td>
        </tr>
        <tr>
          <td>RES SO OD:</td>
          <td>{renderValue(addressData.resSoOd)}</td>
        </tr>
        <tr>
          <td>RES SO DO:</td>
          <td>{renderValue(addressData.resSoDo)}</td>
        </tr>
        <tr>
          <td>LastB PN:</td>
          <td>{renderValue(addressData.lastBPn)}</td>
        </tr>
        <tr>
          <td>LastB WT:</td>
          <td>{renderValue(addressData.lastBWt)}</td>
        </tr>
        <tr>
          <td>LastB SR:</td>
          <td>{renderValue(addressData.lastBSr)}</td>
        </tr>
        <tr>
          <td>LastB CZ:</td>
          <td>{renderValue(addressData.lastBCz)}</td>
        </tr>
        <tr>
          <td>LastB PT:</td>
          <td>{renderValue(addressData.lastBPt)}</td>
        </tr>
        <tr>
          <td>LastB SO:</td>
          <td>{renderValue(addressData.lastBSo)}</td>
        </tr>
        <tr>
          <td>9:</td>
          <td>{renderValue(addressData.service9)}</td>
        </tr>
        <tr>
          <td>12:</td>
          <td>{renderValue(addressData.service12)}</td>
        </tr>
        <tr>
          <td>17-22:</td>
          <td>{renderValue(addressData.service1722)}</td>
        </tr>
        <tr>
          <td>OBSZAR:</td>
          <td>{renderValue(addressData.region)}</td>
        </tr>
        <tr>
          <td>BUDYNEK:</td>
          <td>{renderValue(addressData.building)}</td>
        </tr>
        <tr>
          <td>BUDYNEK DHL:</td>
          <td>{renderValue(addressData.buildingDHL)}</td>
        </tr>
        <tr>
          <td>SO N:</td>
          <td>{renderValue(addressData.soN)}</td>
        </tr>
        <tr>
          <td>SO O:</td>
          <td>{renderValue(addressData.soO)}</td>
        </tr>
        <tr>
          <td>STREFA:</td>
          <td>{renderValue(addressData.zoneName)}</td>
        </tr>
        <tr>
          <td>EX HIST:</td>
          <td>{renderValue(addressData.exHist)}</td>
        </tr>
        <tr>
          <td>EX HIST FROM:</td>
          <td>{renderValue(addressData.exHistFrom)}</td>
        </tr>
        <tr>
          <td>EX HIST TO:</td>
          <td>{renderValue(addressData.exHistTo)}</td>
        </tr>
        <tr>
          <td>DR HIST:</td>
          <td>{renderValue(addressData.drHist)}</td>
        </tr>
        <tr>
          <td>DR HIST FROM:</td>
          <td>{renderValue(addressData.drHistFrom)}</td>
        </tr>
        <tr>
          <td>DR HIST TO:</td>
          <td>{renderValue(addressData.drHistTo)}</td>
        </tr>
        <tr>
          <td>EX COM MET:</td>
          <td>{renderValue(addressData.exComMet)}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default InformationLayerData;
